import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { desktopBridge } from "../lib/desktop";
import { holdEditorDocument } from "../lib/editor-documents";
export function DesktopDocumentOpener() {
  const navigate = useNavigate();
  useEffect(() => {
    const editor = desktopBridge()?.editor;
    if (!editor) return;
    let active = true;
    const receive = async () => {
      const document = await editor.takePending();
      if (!document || !active) return;
      // The draft names the window this document belongs to, so no other editor can adopt it.
      const draft = crypto.randomUUID();
      holdEditorDocument(draft, document);
      navigate(`/app/editor?draft=${draft}`);
    };
    const unsubscribe = editor.onOpen(() => {
      void receive();
    });
    void receive();
    return () => {
      active = false;
      unsubscribe();
    };
  }, [navigate]);
  return null;
}
